import * as colors from 'material-ui/styles/colors';
import spacing from 'material-ui/styles/spacing';
import zIndex from 'material-ui/styles/zIndex';
import { fade } from 'material-ui/utils/colorManipulator';

const BOOKLISTTheme = {
    spacing: spacing,
    zIndex: zIndex,
    fontFamily: 'Roboto, sans-serif',
    palette: {
        primary1Color: colors.blue800,
        primary2Color: colors.lightBlue800,
        primary3Color: colors.lightBlack,
        accent1Color: colors.orange200,
        accent2Color: colors.grey100,
        accent3Color: colors.grey500,
        textColor: colors.darkBlack,
        alternateTextColor: colors.white,
        canvasColor: colors.white,
        borderColor: colors.grey300,
        disabledColor: fade(colors.darkBlack, 0.3),
        pickerHeaderColor: colors.cyan500
    },
    tabs: {
        backgroundColor: colors.grey300,
        selectedTextColor: colors.grey50,
        textColor: colors.grey700
    }
};

export default BOOKLISTTheme